import api from '@/api';
import { CreatePayoutAccountRequest } from '@/types/api/payout-account';
import notify from '@/utils/shared/notify';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreatePayoutAccountMutation() {
  const queryClinet = useQueryClient();

  return useMutation<void, Error, CreatePayoutAccountRequest>({
    mutationKey: ['create-payout-account'],
    mutationFn: (data) => api.payoutAccount.create(data),
    onSuccess: () => {
      notify.success('Utbetalningskonto tillagt!');
      queryClinet.invalidateQueries({
        queryKey: ['payout-accounts'],
      });
    },
  });
}
